module.exports = __webpack_public_path__ + "static/media/barchart.6d589c9c.svg";